import type { MikroWorkOrder, ProductionRun } from "./models";

export function operatorProductNote(run: Pick<ProductionRun, "planNote" | "status" | "workOrderNo" | "productCode" | "lineName" | "workOrderSourceSnapshot"> | null, orders: MikroWorkOrder[]) {
  if (!run) return null;
  const recorded = run.planNote?.trim();
  if (recorded) return { note: recorded, sourceLabel: "İşe kaydedilen not", recorded: true };
  if (run.workOrderSourceSnapshot?.mode === "DIRECT") return null;
  if (run.status !== "ACTIVE") return null;
  const notes = [...new Set(orders.filter(order => order.workOrderNo === run.workOrderNo && order.productCode === run.productCode && order.plannedWorkCenterName === run.lineName)
    .map(order => order.planNote?.trim()).filter((note): note is string => Boolean(note)))];
  return notes.length ? { note: notes.join("\n\n"), sourceLabel: "Etkin plan notu", recorded: false } : null;
}
